<template>
    <div class="widget-inner">
        <template v-if="isPersonalDashboardWidget">
            <template v-if="entries.length">
                <div class="widget-content">
                    <div class="flex" v-for="entry in entries" :class="['padding-top-5', {'bottom-border': content.hasMore || entry !== entries[entries.length - 1]}]">
                        <div v-if="entry.preview_path" class="flex--width-auto widget-image-holder">
                            <img class="widget-image" :src="'/data/image/' + entry.preview_path + 'preview/' + entry.preview_filename" :alt="entry.title + ' Vorschaubild'"/>
                        </div>
                        <div v-else class="flex--width-auto widget-image-holder">
                            <i v-if="icon" class="material-icons font-size-40"
                                aria-hidden="true" :style="{color: icon.color}" role="img">
                                {{icon.icon}}
                            </i>
                        </div>
                        <div class="flex--item-right flex-grow">
                            <router-link :to="buildLink(entry)" class="text-overflow display-block">
                                {{entry.title}}
                            </router-link>

                            <div class="flex">
                                <div class="flex--item-left">
                                    <small>
                                        {{entry.calendar_title}}
                                    </small>
                                </div>
                                <div class="flex--item-right">
                                    {{dateHelper('d.m.Y', entry.recurrence_start)}}
                                    <br/>
                                    <small>
                                        <template v-if="entry.entry_start_time === '00:00:00' && entry.entry_end_time === '24:00:00' || entry.all_day">
                                            ganztägig
                                        </template>
                                        <template v-else-if="entry.entry_start_time">
                                            <template v-if="entry.recurrence_start === entry.recurrence_end && entry.entry_end_time">
                                                {{
                                                    entry.entry_start_time.slice(0, 5)
                                                    + ' - '
                                                    + entry.entry_end_time.slice(0, 5)
                                                }}
                                            </template>
                                            <template v-else>
                                                Ab {{entry.entry_start_time.slice(0, 5)}} Uhr
                                            </template>
                                        </template>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <router-link v-if="content.hasMore" :to="widget.defaultRoute" class="flex margin-right-10 margin-bottom-3">
                    <div class="text-overflow flex--item-right text-underline">
                        <span>Alle ansehen</span>
                        <i class="material-icons small-icon" role="img">open_in_new</i>
                    </div>
                </router-link>
            </template>
            <div v-else class="widget-empty-message">
                <div :style="{color}">
                    {{widget.emptyMessage}}
                </div>
            </div>
        </template>
        <template v-else>
            <div class="widget-empty-message" v-if="!entries.length">
                <i class="material-icons md-96" aria-hidden="true" role="img">{{widget.emptyIcon}}</i>
                <br/>
                {{widget.emptyMessage}}
            </div>
            <ul class="widget-content" v-else>
                <li class="flex" :class="{'background-today': isToday(entry.recurrence_start)}" v-for="entry in entries">
                    <div class="flex" style="align-items: center;margin-right: 10px; flex-direction: column;">
                        {{dateHelper('d.m.Y', entry.recurrence_start)}}
                        <br/>
                        <small>
                            <template v-if="entry.entry_start_time === '00:00:00' && entry.entry_end_time === '24:00:00' || entry.all_day">
                                ganztägig
                            </template>
                            <template v-else-if="entry.entry_start_time">
                                <template v-if="entry.recurrence_start === entry.recurrence_end && entry.entry_end_time">
                                    {{entry.entry_start_time.slice(0, 5) + ' - ' + entry.entry_end_time.slice(0, 5)}}
                                </template>
                                <template v-else>
                                    Ab {{entry.entry_start_time.slice(0, 5)}} Uhr
                                </template>
                            </template>
                        </small>
                    </div>
                    <div class="text-overflow">
                        <router-link :to="buildLink(entry)">{{entry.title}}</router-link>
                        <small v-if="entry.calendar_title">{{entry.calendar_title}}</small>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts">
    import {WidgetCalendarDefault} from './WidgetCalendarDefault.vue';
    import {Component} from 'vue-facing-decorator';

    interface IWidgetEventEntry extends IWidgetCalendarDefaultEntry
    {
        likeable: number;
        canLike: 0 | 1;
        likeStatus: number;
        preview_filename?: string;
        preview_path?: string;
    }

    @Component({
        name: 'WidgetEvent',
        methods: {},
    })
    export default class WidgetEvent extends WidgetCalendarDefault<IWidgetEventEntry>
    {
        get entries(): IWidgetEventEntry[]
        {
            return this.content.entries as IWidgetEventEntry[];
        }

        get icon(): Nullable<{ icon: string, color: string }>
        {
            let module = this.layoutData.modules.find(module => module.resource === 'event');

            return module ? {
                icon: module.icon,
                color: '#' + module.color,
            } : null;
        }
    }
</script>